import { render, staticRenderFns } from "./BulkDispatchGuidePreview.vue?vue&type=template&id=462b2834&scoped=true&"
import script from "./BulkDispatchGuidePreview.vue?vue&type=script&lang=js&"
export * from "./BulkDispatchGuidePreview.vue?vue&type=script&lang=js&"
import style0 from "./BulkDispatchGuidePreview.vue?vue&type=style&index=0&id=462b2834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b2834",
  null
  
)

export default component.exports